<template>
	<div v-if="loaded && localPhotos.length > 0">
		<b-carousel
			:key="carouselKey"
			indicators
			controls
			class="carousel"
			:interval="0"
			v-model="slide"
		>
			<b-carousel-slide
				v-for="(photo, index) in localPhotos"
				:key="`slide-${index}-${photo.idgaleria || photo.url}`"
			>
				<template #img>
					<img
						class="carousel-img"
						:src="photoUrl(photo)"
						:alt="`Imagen ${index + 1} de ${localPhotos.length}`"
					/>
				</template>
			</b-carousel-slide>
		</b-carousel>
	</div>
	<div v-else-if="loaded && localPhotos.length === 0" class="no-photos">
		No hay imágenes disponibles
	</div>
</template>

<script>
import axios from "axios";
export default {
	name: "CarouselList",
    props: {
        idAlojamiento: {},
        externalReference: {},
        photos: {
            type: Array,
            default: () => []
        }
    },
	data() {
		return {
			url: process.env.VUE_APP_S3_URL,
			loaded: false,
			localPhotos: [],
			slide: 0,
			carouselKey: 0,
		};
	},
	created() {
        // Si las fotos vienen por prop, usarlas
        if(this.photos && this.photos.length > 0) {
            this.localPhotos = [...this.photos];
            this.loaded = true;
        } else {
            // Si no, cargarlas desde la API
            axios({
                url:
                    process.env.VUE_APP_API_URL +
                    "galleries/searchByAccommodation/" +
                    this.idAlojamiento,
                method: "GET",
            }).then((resp) => {
                this.localPhotos = resp.data.photos || [];
                this.loaded = true;
            }).catch((err) => {
                console.error("Error cargando galería:", err);
                this.loaded = true;
            });   
        }
    },
    watch: {
        photos: {
            handler(newPhotos) {
                if(newPhotos && newPhotos.length > 0) {
                    this.localPhotos = [...newPhotos];
                    this.carouselKey++;
                    this.slide = 0;
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        photoUrl(photo) {
            const rawUrl = photo && photo.url ? photo.url : '';
            const finalUrl = this.normalizeS3ImageUrl(rawUrl);

            return finalUrl;
        },
        normalizeS3ImageUrl(url) {
            if (!url) return '';

            const bucket = (process.env.VUE_APP_AWS_BUCKET_URL || '').replace(/^\/+|\/+$/g, '');
            if (url.indexOf('http') === -1) {
                return this.url + url;
            }

            if (!bucket || url.indexOf('s3-sa-east-1.amazonaws.com') === -1 || url.indexOf(bucket) > -1) {
                return url;
            }

            try {
                const parsedUrl = new URL(url);
                parsedUrl.pathname = `/${bucket}/${parsedUrl.pathname.replace(/^\/+/, '')}`;
                return parsedUrl.toString();
            } catch (e) {
                return url;
            }
        }
    }
    
};
</script>

<style lang="scss" scoped>

.carousel {
    width: 100%;
    height: 220px;
    overflow: hidden;
}

.carousel-img {
    width: 100%;
    height: 220px;
    object-fit: cover;
    display: block;
}

.no-photos {
    padding: 40px;
    text-align: center;
    color: #666;
}

</style>
